import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,
      marginBottom: 1,
    },
    text: {
      color: colors.grey_500,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '129%',
    },
  };
};
